const appType = {
    SET_PAGE_CURRENT: 'SET_PAGE_CURRENT',
}

export default appType;